import React, { useEffect, useState } from 'react'
import { Modal, Backdrop, Fade, Popper, Box } from "@material-ui/core";
import { Typography, OutlinedInput, InputAdornment, Button, Paper, TablePagination } from "@material-ui/core";
import { Search, ArrowDropDown as ArrowDropDownIcon } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';
import { getDatafromDataModelIdPayload } from '../../utils/payload'
import DataTable from '../DataTable/DataTable'
import ExternalFilter from '../../../ObligationOverviewV3/Spend/ExternalFilter'

const useStyles = makeStyles(() => ({
    smallPagination: {
        "& .MuiTablePagination-caption": {
            flexShrink: 0,
            fontSize: "12px",
        },
        "& .MuiTablePagination-selectRoot": {
            fontSize: "12px",
        },
        "& .MuiTablePagination-displayedRows": {
            fontSize: "12px",
        },
        "& .MuiTablePagination-actions .MuiIconButton-root": {
            padding: "4px",
        },
        "& .MuiTablePagination-actions svg": {
            fontSize: "16px",
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: '#fff',
        boxShadow: 'none',
    },

    /* Inputs */
    inputRoot: {
        height: '32px',
        padding: '5px 8px 6px 8px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    },
    inputRoot1: {
        height: '32px',
        width: '250px',
        padding: '5px 8px 6px 8px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    },
    inputText: {
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
    },

    /* Modal layout */
    modalContainer: {
        height: 760,
        width: 800,
        borderRadius: 8,
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        margin: 'auto',
        outline: 'none',
        overflow: 'visible',
        position: 'relative',
    },
    headerBar: {
        height: 50,
        padding: '16px 10px',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 10,
        borderBottom: '1px solid #E0E0E0'
    },
    headerTitle: {
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        color: 'rgba(33, 33, 33, 1)'
    },
    selectedCount: {
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        color: 'rgba(63, 81, 181, 1)'
    },
    sectionContainer: {
        padding: 16,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        borderBottom: '1px solid #E0E0E0'
    },
    topRow: {
        height: 55,
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10
    },
    columnGap6: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6
    },
    mutedLabel: {
        fontSize: 12,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(146, 147, 166, 1)'
    },

    /* Filters row scroller */
    filtersScroller: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        gap: 10,
        marginLeft: 'auto',
    },
    filterPopper: {
        zIndex: 1500,
        width: 560,
        maxWidth: 'calc(100vw - 48px)',
        maxHeight: 'min(70vh, 520px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        boxShadow: '0 10px 19.6px 0 #E7E8EB',
        border: '1px solid #e0e0e0',
        borderRadius: 10,
        backgroundColor: '#fff',
    },
    filterField: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        minWidth: 120,
        flexShrink: 0,
    },

    /* Icons */
    searchIcon: {
        fontSize: 19,
        cursor: 'pointer',
        color: 'rgba(95, 96, 113, 1)'
    },
    searchIconSmall: {
        fontSize: 14,
        color: 'rgba(95, 96, 113, 1)'
    },

    /* Popover */
    popoverPaper: (props) => ({
        boxShadow: 'none',
        border: '1px solid rgba(213, 214, 221, 1)',
        marginTop: 2,
        width: props?.popoverWidth || 'auto',
    }),
    popoverContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    popoverSearchWrapper: {
        padding: 6
    },
    popoverSearchInput: {
        marginBottom: 4,
        width: '100%'
    },
    popoverList: {
        maxHeight: 200,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    menuItem: {
        boxShadow: 'none',
        fontSize: 12,
        padding: 0,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(146, 147, 166, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 160
    },
    menuItemBold: {
        fontWeight: 500
    },
    optionLabel: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        maxWidth: '100%'
    },
    buttonRow: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        height: 50,
        boxSizing: 'border-box',
        gap: 10,
        padding: '12px 16px'
    },
    btnOutlineSmall: {
        height: 14,
        width: 40,
        padding: 10,
        backgroundColor: 'transparent',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(63, 81, 181, 1)',
        fontSize: 11,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: 'transparent',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },

    },
    btnPrimarySmall: {
        height: 14,
        width: 40,
        padding: 10,
        backgroundColor: '#3F51B5',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(255, 255, 255, 1)',
        fontSize: 11,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: '#3F51B5',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },
    },

    /* Loader & table scroll */
    loaderContainer: {
        minHeight: 768,
        overflowY: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    tableScroll: {
        maxHeight: 500,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    paginationContainer: {
        marginTop: 5
    },

    /* Footer buttons */
    footerBar: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        height: 50,
        boxSizing: 'border-box',
        gap: 10,
        padding: '12px 16px'
    },
    btnOutline: {
        height: 38,
        width: 68,
        padding: '12px 16px',
        backgroundColor: 'transparent',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(63, 81, 181, 1)',
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: 'transparent',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },
    },
    btnPrimary: {
        height: 38,
        width: 150,
        padding: '12px 16px',
        backgroundColor: '#3F51B5',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(255, 255, 255, 1)',
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: '#3F51B5',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },
    },
}));

const ModelWithTableViewer = (props) => {
    const { formData, open, handleCloseModel, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, selectedOptions, menuOptions, keyVal, chartUniqueId, appId, block, parentBlockState } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useStyles({ popoverWidth: anchorEl?.clientWidth });

    const [blockState, setBlockState] = useState([])
    const [totalRecords, setTotalRecords] = React.useState(0);
    const [blockHeaders, setBlockHeaders] = useState([])
    const [selectedDocuments, setSelectedDocuments] = useState([])

    const [filterConditions, setFilterConditions] = useState([])
    const [filterButtonText, setFilterButtonText] = useState('Filter by');
    const [savedFilterData, setSavedFilterData] = useState(null);
    const [localSelectedFilterData, setLocalSelectedFilterData] = useState(null);
    const [mainSearchTerm, setMainSearchTerm] = useState('');

    const externalFilterConfig = block?.config?.[0]?.externalFilter || [];

    console.log('ModelWithTableViewer**blockState', blockState, props)

    // Function to handle main search input change
    const handleMainSearchChange = (event) => {
        setMainSearchTerm(event.target.value);
    };

    // Function to handle main search
    const handleMainSearch = () => {
        getDatafromDataModelId(mainSearchTerm);
    };

    // Function to handle search on Enter key press
    const handleMainSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleMainSearch();
        }
    };

    // Function to handle search icon click
    const handleSearchIconClick = () => {
        handleMainSearch();
    };
    console.log("ModelWithTableViewer props ===> ", blockHeaders, blockState, totalRecords, props, filterConditions);

    /** Opens the shared ExternalFilter popper and warms its dropdown options. */
    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
        prefetchExternalFilterData();
    };

    /** Converts ExternalFilter values into the conditions payload used by getModelData. */
    const convertFilterValuesToConditions = (filterValues = {}) => {
        const nextConditions = [];

        externalFilterConfig.forEach((item) => {
            const filterValue = filterValues?.[item.value];
            if (filterValue && Array.isArray(filterValue) && filterValue.length > 0) {
                nextConditions.push({
                    selectedConditionClause: 'and',
                    selectedConditionDataElement: item.value,
                    selectedConditionOperator: 'in',
                    value: filterValue.map((entry) => (
                        entry && typeof entry === 'object' && 'value' in entry ? entry.value : entry
                    )),
                });
                return;
            }

            if (filterValue && typeof filterValue === 'object' && (filterValue.startDate || filterValue.endDate)) {
                nextConditions.push({
                    selectedConditionClause: 'and',
                    selectedConditionDataElement: item.value,
                    selectedConditionOperator: 'between',
                    value: [filterValue.startDate, filterValue.endDate].filter(Boolean),
                });
            }
        });

        return nextConditions;
    };

    /** Counts selected filter chips for the Filter by button label. */
    const calculateSelectedFiltersCount = (filterValues = {}) => {
        let totalCount = 0;
        Object.values(filterValues || {}).forEach((value) => {
            if (value && Array.isArray(value) && value.length > 0) {
                totalCount += value.length;
            } else if (value && typeof value === 'object' && (value.startDate || value.endDate)) {
                totalCount += 1;
            }
        });
        return totalCount;
    };

    /** Updates the Filter by button label from the current local filter selection. */
    const updateFilterCalculations = (filterValues = localSelectedFilterData) => {
        const selectedFiltersCount = calculateSelectedFiltersCount(filterValues || {});
        setFilterButtonText(selectedFiltersCount > 0 ? `Filter added (${selectedFiltersCount})` : 'Filter by');
    };

    /** Closes the filter popper; only Save / Clear apply conditions. */
    const handleFilterClose = (action) => {
        if (action === 'save') {
            const nextConditions = convertFilterValuesToConditions(localSelectedFilterData || {});
            setSavedFilterData(localSelectedFilterData);
            setFilterConditions(nextConditions);
            updateFilterCalculations(localSelectedFilterData);
        } else if (action === 'clear') {
            const clearedFilters = {};
            externalFilterConfig.forEach((item) => {
                clearedFilters[item.value] = null;
            });
            setLocalSelectedFilterData(clearedFilters);
            setSavedFilterData(null);
            setFilterConditions([]);
            updateFilterCalculations(clearedFilters);
        } else if (action === 'close') {
            setLocalSelectedFilterData(savedFilterData || null);
            updateFilterCalculations(savedFilterData || {});
        }
        setAnchorEl(null);
    };

    /** Keeps temporary ExternalFilter selections while the popper is open. */
    const handleExternalFilterChange = (updatedFilters) => {
        setLocalSelectedFilterData(updatedFilters);
    };

    /**
     * Builds option lists for ExternalFilter from the formData dropdown cache.
     * Uncached fields must stay `null` (not `[]`) so ExternalFilter still treats them as
     * unloaded and fetches them on click.
     */
    const getExternalFilterData = () => {
        return externalFilterConfig.map((item) => (
            formData?.externalFilterData?.[`${chartUniqueId}_externalFilter_${item.value}`] || null
        ));
    };

    /** Loads dropdown options for every configured select filter, using ExternalFilter's cache keys. */
    const prefetchExternalFilterData = () => {
        if (!props.getModelDataDropDown) {
            return;
        }

        externalFilterConfig.forEach((item) => {
            if (!item?.value || item.type === 'date' || item.isDate) {
                return;
            }

            const dataUniqueId = `${chartUniqueId}_externalFilter_${item.value}`;
            if (formData?.externalFilterData?.[dataUniqueId]) {
                return;
            }

            props.getModelDataDropDown({
                appId: appId,
                id: block?.dataModel || keyVal,
                rowsPerPage: 'all',
                conditions: [],
                field: item.value,
                dataUniqueId,
            });
        });
    };

    const isAllSelected = blockState.length > 0 && selectedDocuments.length === blockState.length;
    const isIndeterminate = selectedDocuments.length > 0 && selectedDocuments.length < blockState.length;

    const getDatafromDataModelId = (searchKey) => {
        let modelDatapayload = getDatafromDataModelIdPayload(appId, keyVal, page, rowsPerPage, filterConditions)
        if (searchKey) {
            modelDatapayload['search'] = searchKey;
        }
        props.getModelData({ ...modelDatapayload, dataUniqueId: chartUniqueId + '_assosiateddata' });
    }

    useEffect(() => {
        getDatafromDataModelId()
    }, [page, rowsPerPage, filterConditions])

    const handleDocumentSelection = (documentId, dataModel, isSelected) => {
        if (isSelected) {
            setSelectedDocuments(prev => {
                const newSelected = [...prev];
                const existingIndex = newSelected.findIndex(doc => doc.id === documentId);

                if (existingIndex === -1) {
                    newSelected.push({
                        id: documentId,
                        dataModel: dataModel
                    });
                }

                return newSelected;
            });
        } else {
            setSelectedDocuments(prev => prev.filter(doc => doc.id !== documentId));
        }
    }

    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allDocuments = blockState.map(row => ({
                id: row.id || row._id || row.documentId,
                dataModel: block.dataModel || keyVal
            }));
            setSelectedDocuments(allDocuments);
        } else {
            setSelectedDocuments([]);
        }
    }

    const handleSaveDocuments = () => {
        const existingLinkedRefs = parentBlockState?.linkedReferenceDocument || [];

        const documentsByDataModel = {};
        selectedDocuments.forEach(doc => {
            if (!documentsByDataModel[doc.dataModel]) {
                documentsByDataModel[doc.dataModel] = [];
            }
            documentsByDataModel[doc.dataModel].push(doc.id);
        });

        const newLinkedReferenceDocument = [...existingLinkedRefs];

        Object.keys(documentsByDataModel).forEach(dataModel => {
            const documentIds = documentsByDataModel[dataModel];

            const existingIndex = newLinkedReferenceDocument.findIndex(item => item.dataModel === dataModel);

            if (existingIndex !== -1) {
                const existingDocs = newLinkedReferenceDocument[existingIndex].documents || [];
                const mergedDocs = [...new Set([...existingDocs, ...documentIds])];
                newLinkedReferenceDocument[existingIndex] = {
                    ...newLinkedReferenceDocument[existingIndex],
                    documents: mergedDocs
                };
            } else {
                newLinkedReferenceDocument.push({
                    dataModel: dataModel,
                    documents: documentIds
                });
            }
        });

        if (props.isCallingoutside === null || props.isCallingoutside === undefined || props.isCallingoutside === false) {
            if (props.setBlockState) {
                props.setBlockState({
                    ...parentBlockState,
                    linkedReferenceDocuments: newLinkedReferenceDocument
                });
            }

            if (props.match?.params?.id && props.onEditModeChange) {
                props.onEditModeChange(true);
            }
        }
        else {
            props.handleSaveDocumentsOutside(newLinkedReferenceDocument, selectedDocuments);
        }

        // if (props.match?.params?.id && props.onEditModeChange) {
        //     props.onEditModeChange(true);
        // }

        handleCloseModel();
    }

    const initializeSelectedDocuments = () => {
        if (parentBlockState?.linkedReferenceDocuments) {
            const existingSelected = [];
            parentBlockState.linkedReferenceDocuments.forEach(item => {
                if (item.dataModel === block.dataModel && item.documents) {
                    item.documents.forEach(docId => {
                        existingSelected.push({
                            id: docId,
                            dataModel: item.dataModel
                        });
                    });
                }
            });
            setSelectedDocuments(existingSelected);
        }
        else {
            setSelectedDocuments([]);
        }
    };

    useEffect(() => {
        if (open) {
            initializeSelectedDocuments();
        }
    }, [open, parentBlockState]);

    useEffect(() => {
        if (formData?.dataModel[block.dataModel || selectedStep.dataModel]) {
            let dataElements = formData.dataModel[block.dataModel || selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                console.log("Cmng here 000 ===> ", block?.config[0]?.dataElements, block?.config[0]?.dataElements?.length);
                if (block?.config[0]?.dataElements) {
                    console.log("Cmng here 000 ===> ", block?.config[0]?.dataElements, dataElements);
                    fdes = JSON.parse(JSON.stringify(block?.config[0]?.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return {
                                ...sde,
                                ...fde
                            }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                    console.log("Fdes 000 ===> ", fdes);
                }
            }
        }
    }, [keyVal])


    useEffect(() => {
        if (formData?.document[chartUniqueId + '_assosiateddata']?.data?.length) {
            let dataList = formData?.document[chartUniqueId + '_assosiateddata']?.data || []
            let total = formData?.document[chartUniqueId + '_assosiateddata']?.total || []
            setBlockState(dataList)
            setTotalRecords(total)

        } else {
            setBlockState([])
            setTotalRecords(0)
        }
    }, [props.formData?.document[chartUniqueId + '_assosiateddata']])

    useEffect(() => {
        getDatafromDataModelId()
    }, [keyVal])

    const cellStyle = {
        padding: '8px',
        border: '1px solid rgba(233, 235, 245, 1)',
    };

    const cellStyle23 = {
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(95, 96, 113, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px',
    }

    const cellStyle1 = {
        padding: '8px',
        fontSize: '12px',
        fontWeight: '500',
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(95, 96, 113, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 80,
        border: '1px solid rgba(233, 235, 245, 1)',
    };

    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                // Close only via footer Close / Cancel button — not backdrop or Escape.
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                handleCloseModel();
            }}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
            disableEscapeKeyDown
            disableEnforceFocus
            disableAutoFocus
        >
            <Fade in={open}>
                <div className={classes.modalContainer}>
                    <div className={classes.headerBar}>
                        <Typography className={classes.headerTitle}>
                            Select Document
                        </Typography>

                        {selectedDocuments.length > 0 && (
                            <Typography className={classes.selectedCount}>
                                {selectedDocuments.length} Document{selectedDocuments.length !== 1 ? 's' : ''} Selected
                            </Typography>
                        )}
                    </div>

                    <div className={classes.sectionContainer}>
                        <div className={classes.topRow}>
                            {
                                block?.config[0]?.isSearch && (
                                    <div className={classes.columnGap6}>
                                        <Typography className={classes.mutedLabel}>
                                            Search
                                        </Typography>
                                        <OutlinedInput
                                            variant="outlined"
                                            classes={{ root: classes.inputRoot1 }}
                                            value={mainSearchTerm}
                                            onChange={handleMainSearchChange}
                                            onKeyPress={handleMainSearchKeyPress}
                                            inputProps={{ className: classes.inputText }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <Search
                                                        className={classes.searchIcon}
                                                        onClick={handleSearchIconClick}
                                                    />
                                                </InputAdornment>
                                            }
                                            placeholder={"Search Here ..."}
                                        />
                                    </div>
                                )
                            }

                            {
                                block?.config[0]?.isFilter && externalFilterConfig.length > 0 && (
                                    <div className={classes.filtersScroller}>
                                        <Button
                                            variant="contained"
                                            endIcon={<ArrowDropDownIcon />}
                                            onClick={handleFilterClick}
                                            style={{
                                                backgroundColor: '#1976d2',
                                                color: 'white',
                                                textTransform: 'none'
                                            }}
                                        >
                                            {filterButtonText}
                                        </Button>
                                    </div>
                                )
                            }

                        </div>

                        <div>
                            {
                                (props.formData?.[chartUniqueId + '_assosiateddata_loading'] || props.formData?.[(block.dataModel || selectedStep.dataModel) + '_loading']) ? (
                                    <div className={`myScrollContainer ${classes.loaderContainer}`}>
                                        {props.loader}
                                    </div>
                                ) : (
                                    <div>
                                        <div className={`myScrollContainer ${classes.tableScroll}`}>
                                            <DataTable
                                                headers={blockHeaders}
                                                data={blockState}
                                                showCheckbox={true}
                                                selectedItems={selectedDocuments.map(doc => doc.id)}
                                                onSelectionChange={(documentId, isSelected) => {
                                                    handleDocumentSelection(documentId, block.dataModel || keyVal, isSelected);
                                                }}
                                                onSelectAll={handleSelectAll}
                                                page={page}
                                                rowsPerPage={rowsPerPage}
                                                totalRecords={totalRecords}
                                                showPagination={false}
                                                onPageChange={handleChangePage}
                                                uniqueId={789}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                match={props.match} 
                                                history={props.history}
                                            />
                                        </div>
                                        <div className={classes.paginationContainer}>
                                            <TablePagination
                                                component="div"
                                                count={totalRecords}
                                                className={classes.smallPagination}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className={classes.footerBar}>
                        <Button variant="contained" className={classes.btnOutline} onClick={() => { handleCloseModel() }}>Close</Button>
                        <Button variant="contained" className={classes.btnPrimary} onClick={handleSaveDocuments}>Add Document</Button>
                    </div>

                    <Popper
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        placement="bottom-end"
                        disablePortal={false}
                        modifiers={{
                            flip: { enabled: true },
                            preventOverflow: {
                                enabled: true,
                                boundariesElement: 'viewport',
                                padding: 16,
                            },
                            offset: {
                                enabled: true,
                                offset: '0, 8',
                            },
                        }}
                        style={{ zIndex: 1500 }}
                    >
                        <Paper className={classes.filterPopper} elevation={0}>
                            <Box style={{ padding: '16px 20px 20px' }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
                                    Filter
                                </Typography>
                                <ExternalFilter
                                    {...props}
                                    externalFilters={externalFilterConfig.map((item) => ({
                                        value: item.value,
                                        label: item.label,
                                        type: item.type === 'date' || item.isDate ? 'date' : (item.type || 'select')
                                    }))}
                                    externalFilterData={getExternalFilterData()}
                                    externalFilterValues={localSelectedFilterData !== null ? localSelectedFilterData : {}}
                                    onExternalFilterChange={handleExternalFilterChange}
                                    setLocalSelectedFilterData={setLocalSelectedFilterData}
                                    localSelectedFilterData={localSelectedFilterData}
                                    align="vertical"
                                    isNewV1Theme={true}
                                    disableOuterChrome={true}
                                    dataModelId={block?.dataModel || keyVal}
                                    appId={appId}
                                    dataUniqueId={chartUniqueId}
                                    getModelDataDropDown={props.getModelDataDropDown}
                                    formData={props.formData}
                                    conditions={filterConditions}
                                />
                                <Box style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    paddingTop: '16px',
                                    marginTop: '8px',
                                    borderTop: '1px solid #e0e0e0'
                                }}>
                                    <Button
                                        onClick={() => handleFilterClose('clear')}
                                        style={{
                                            color: '#1976d2',
                                            textTransform: 'capitalize'
                                        }}
                                    >
                                        Clear All
                                    </Button>
                                    <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto' }}>
                                        <Button
                                            onClick={() => handleFilterClose('close')}
                                            style={{
                                                color: '#1976d2',
                                                textTransform: 'capitalize',
                                                height: 32,
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button
                                            onClick={() => handleFilterClose('save')}
                                            variant="contained"
                                            style={{
                                                backgroundColor: '#1976d2',
                                                color: 'white',
                                                textTransform: 'capitalize',
                                                height: 32,
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Box>
                            </Box>
                        </Paper>
                    </Popper>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModelWithTableViewer
